const defaultConfirmDialog = {
  show: false,
  header: 'message',
  action: '',
  data: null,
  nextTickAction: '',
  nextTickData: null,
}

export default {
  namespaced: true,
  state: {
    pageTitle: '',
    confirmDialog: defaultConfirmDialog,
    toast: {
      message: '',
      color: '',
      delay: 1,
    },
  },
  actions: {
    SHOW_CONFIRM_DIALOG: async function({ commit }, data) {
      commit('setConfirmDialog', { ...defaultConfirmDialog, ...data, show: true })
    },
    CLOSE_CONFIRM_DIALOG: async function({ commit }) {
      commit('setConfirmDialog', defaultConfirmDialog)
    },
    SET_TOAST: function({ commit }, toast) {
      commit('setToast', toast)
    },
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
  },
  getters: {
  },
  mutations: {
    setConfirmDialog(state, data) {
      state.confirmDialog = data
    },
    setToast: function(state, toast) {
      state.toast = { ...toast }
    },
    setField: function(state, data) {
      state[data.key] = data.value
    },
  },
}
